module.exports = __webpack_public_path__ + "images/Plus.4e0538bcdc634546bc03d6d08d264d94.svg";